import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features';

import { injectHouseholdsSlice } from '@/app/householdsApi';

import {
  AddSealPayload,
  DeleteSealPayload,
  SealFull,
  UpdateSealPayload,
} from './types';

export const transformSeal = (seal: SealFull) => ({
  ...seal,
  name:
    [seal.sealTypeName, seal.series, seal.number].filter(Boolean).join(' ') ||
    null,
});

export const meteringPointSealsApi = injectHouseholdsSlice({
  baseUrl: `${Config.VITE_API_URL}/metering-points`,
  tagTypes: ['MeteringPointSeal', 'MeteringPointSeals'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getSealById: builder.query<
      SealFull,
      { meteringPointId: string; sealId: string }
    >({
      query: ({ meteringPointId, sealId }) => ({
        url: `/${meteringPointId}/seals/${sealId}`,
      }),
      transformResponse: transformSeal,
      providesTags: (_, __, { sealId }) => [
        { type: 'MeteringPointSeal', id: sealId },
      ],
    }),
    createSeal: builder.mutation<void, AddSealPayload>({
      query: data => ({
        url: `/${data.meteringPointId}/seals`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['MeteringPointSeals'],
    }),
    updateSeal: builder.mutation<void, UpdateSealPayload>({
      query: data => ({
        url: `/${data.meteringPointId}/seals/${data.id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: (_, __, { id }) => [
        'MeteringPointSeals',
        { type: 'MeteringPointSeal', id },
      ],
    }),
    deleteSeal: builder.mutation<void, DeleteSealPayload>({
      query: data => ({
        url: `/${data.meteringPointId}/seals/${data.id}`,
        method: 'DELETE',
        data,
      }),
      invalidatesTags: (_, __, { id }) => [
        'MeteringPointSeals',
        { type: 'MeteringPointSeal', id },
      ],
    }),
  }),
});

export const {
  useGetSealByIdQuery,
  useCreateSealMutation,
  useUpdateSealMutation,
  useDeleteSealMutation,
} = meteringPointSealsApi;
